export const navLinks = [
  { id: "hero", label: "Home" },
  { id: "about", label: "About" },
  { id: "services", label: "Work" },
  { id: "why-us", label: "Why Us" },
  { id: "team", label: "Team" },
  { id: "contact", label: "Contact" },
];

export const sectionIds = navLinks.map((link) => link.id);

export const heroHighlights = [
  "Client software delivery for growing businesses",
  "Custom systems shaped around real business workflows",
  "Long-term support from product strategy to launch",
];

export const aboutPoints = [
  "We design, build, and improve software for clients who need practical digital tools that support real operations.",
  "We work closely with businesses to shape software around the daily realities of operations, growth, and service delivery.",
  "We work closely with founders and operators so the final product fits the business, not just the brief.",
];

export const workItems = [
  {
    slug: "julian-interiors",
    name: "Julian Interiors",
    type: "Client delivery",
    description:
      "Custom software support for a growing interior business, focused on making day-to-day operations easier to manage.",
    image: "assets/img/interior.jpg",
    linkLabel: "View details",
    status: "Ongoing client work",
    headline:
      "Software support tailored to a growing interiors business.",
    overview:
      "Julian Interiors represents the kind of client work we enjoy most: software shaped around real operations, fast feedback, and practical results for a team that is growing.",
    challenge:
      "As a business grows, everyday coordination gets more complex. Teams need clearer workflows, better visibility, and systems that reduce manual friction instead of adding to it.",
    solution:
      "We support Julian Interiors with custom software thinking focused on structure, simplicity, and the day-to-day needs of the business. The goal is to make the work easier to manage and easier to scale.",
    capabilities: [
      "Business workflow discovery",
      "Custom internal tooling ideas",
      "Operational process improvement",
      "Direct collaboration with decision-makers",
    ],
    outcomes: [
      "A clearer direction for digital workflow improvement",
      "Software decisions grounded in real business activity",
      "A practical path for future feature growth",
    ],
    liveUrl: "https://julian-interiors.com/",
    cta: "Discuss a similar client project",
  },
  {
    slug: "keja-zone",
    name: "Keja Zone",
    type: "In-house product",
    description:
      "A rental and property management platform designed to help agencies, landlords, and tenants manage the full rental lifecycle in one place.",
    image: "assets/img/1.jpg",
    linkLabel: "View details",
    status: "In-house platform",
    headline:
      "Property management and rental booking built for structured day-to-day operations.",
    overview:
      "Keja Zone is a property management and rental booking platform built to simplify how landlords, agencies, and tenants manage the full rental lifecycle in one system. It combines operational rental management with public-facing rental discovery and booking.",
    challenge:
      "Rental operations often get split across messages, spreadsheets, paper documents, and disconnected tools. That makes it harder to track listings, review bookings, manage occupancy changes, handle billing, and keep contracts and tenant documents organized.",
    solution:
      "We designed Keja Zone as a structured platform where landlords and agencies can manage multiple properties and units, define booking requirements, review approval workflows, attach reusable contract templates, and oversee tenant movement from discovery through booking, lease approval, billing, and occupancy.",
    capabilities: [
      "Property and unit listing management",
      "Tenant booking and approval workflows",
      "Media, document, and contract handling",
      "Lease, billing, and dynamic charge management",
      "Role-based access control for multi-tenant operations",
      "Public rental discovery and booking endpoints",
    ],
    outcomes: [
      "A single operational system for rental lifecycle management",
      "Better visibility across properties, bookings, leases, and occupancy changes",
      "A platform that works for agencies, landlords, and digital property marketplaces",
      "A backend foundation with standardized APIs, file storage integration, and deployment automation",
    ],
    liveUrl: "https://website-f06d9238.pih.zkb.mybluehost.me/",
    cta: "Discuss a similar product or platform",
  },
  {
    slug: "lease-matrix",
    name: "LeaseMatrix",
    type: "In-house product",
    description:
      "A combined leasing, asset financing, accounting, procurement, workflow, and analytics platform for companies that need every operational transaction connected to financial controls.",
    image: "assets/img/finance-command-center.png",
    linkLabel: "View details",
    status: "In-house platform",
    headline:
      "One operating system for leasing, asset financing, accounting, procurement, and analytics teams.",
    overview:
      "LeaseMatrix is owned and developed by Operating Software Ltd as a modular enterprise platform for leasing and financing teams. It brings customer operations, supplier settlement, accounting postings, approvals, documents, billing, collections, and dashboards into one controlled workflow, and it can be customized around internal controls, reporting needs, and preferred business processes.",
    challenge:
      "Leasing and asset-financing businesses often run critical work across disconnected systems, which makes approvals harder to control, accounting harder to trace, and reporting harder to trust. Operational teams need lease activity, supplier workflows, financial postings, documents, and management visibility connected in one audit-ready platform.",
    solution:
      "We built LeaseMatrix as a customizable operating system that connects lease operations, asset financing, accounting, procurement, customer risk, collections, asset ownership, and analytics. The platform supports traditional leasing and financing-to-own transactions from onboarding and origination through approval routing, contract activation, billing, repayment, reporting, and final ownership transfer.",
    capabilities: [
      "Lease operations covering applications, approvals, contracts, renewals, terminations, billing, collections, arrears, recovery, and customer statements",
      "Asset financing workflows for supplier quotations, deposits, interest calculation, installment repayment, supplier settlement, asset security, and ownership transfer",
      "Accounting and finance controls including general ledger, receivables, payables, bank, cash, tax, journals, financial statements, period closing, and source-document traceability",
      "Procurement and supplier workflows with onboarding, requisitions, purchase orders, goods receipts, supplier bills, three-way matching, and payment routing",
      "Customer and credit-risk management with KYC, guarantors, risk ratings, exposure tracking, blacklists, and profitability reporting",
      "Asset and ownership tracking with registration, tagging, assignment, maintenance, insurance, depreciation, repossession, disposal, and transfer management",
      "Multi-currency, approval, audit, security, and document traceability controls across the platform",
      "Custom implementation around modules, approval matrix, accounting rules, reports, document templates, integrations, branches, currencies, and workflows",
    ],
    outcomes: [
      "An audit-ready operating model where operational transactions stay connected to financial controls",
      "End-to-end visibility from customer and supplier onboarding through billing, repayment, reporting, and ownership transfer",
      "Stronger accounting discipline through approval trails, source-document links, role-based controls, and management dashboards",
      "A customizable enterprise platform that can fit different business models, reporting expectations, and internal control requirements",
    ],
    liveUrl: "https://website-f06d9238.pih.zkb.mybluehost.me/",
    cta: "Discuss a similar leasing or financing platform",
  },
];

export function getProjectBySlug(slug) {
  return workItems.find((item) => item.slug === slug);
}

export const serviceOfferings = [
  {
    slug: "custom-software-development",
    title: "Customized Software Development",
    icon: "bi-code-slash",
    summary:
      "We design and build software around the way your business actually works instead of forcing your team into generic tools.",
    description:
      "From internal systems to customer-facing platforms, we create tailored software that supports real workflows, growth plans, and operational clarity.",
    deliverables: [
      "Custom web applications",
      "Internal business systems",
      "Product strategy and feature planning",
      "Ongoing improvement and technical support",
    ],
  },
  {
    slug: "business-automation",
    title: "Business Automation",
    icon: "bi-gear-wide-connected",
    summary:
      "We help teams reduce repetitive manual work by designing systems and automations that make operations more efficient.",
    description:
      "Business automation is about saving time, reducing errors, and giving your team better visibility into what matters. We identify bottlenecks and build practical solutions around them.",
    deliverables: [
      "Workflow mapping and process review",
      "Automation of repetitive tasks",
      "Operational dashboards and alerts",
      "System integrations where needed",
    ],
  },
  {
    slug: "digital-marketing-branding",
    title: "Digital Marketing and Branding",
    icon: "bi-megaphone",
    summary:
      "We support businesses that need stronger digital visibility, sharper messaging, and a more consistent brand presence.",
    description:
      "Good software still needs clear positioning. We help shape branding, digital communication, and marketing support that makes your business easier to understand and trust.",
    deliverables: [
      "Brand messaging support",
      "Digital campaign planning",
      "Content and communication direction",
      "Positioning support for products and businesses",
    ],
  },
  {
    slug: "tech-accessories-sourcing",
    title: "Tech Accessories Sourcing",
    icon: "bi-headset-vr",
    summary:
      "We help source practical tech accessories and hardware support items for teams, projects, and business operations.",
    description:
      "When businesses need dependable access to selected tech accessories, we help simplify sourcing so they can get what they need with less friction.",
    deliverables: [
      "Accessory sourcing support",
      "Procurement guidance for practical tech needs",
      "Recommendations based on use case",
      "Reliable coordination around supply requests",
    ],
  },
];

export const serviceProcess = [
  {
    title: "Understand the need",
    description:
      "We begin with the real business problem, current workflow, and the outcome you want to create.",
  },
  {
    title: "Shape the right solution",
    description:
      "We recommend the most practical path, whether that is custom software, automation, branding support, or sourcing help.",
  },
  {
    title: "Deliver with clarity",
    description:
      "We keep communication direct, progress visible, and implementation grounded in the realities of your business.",
  },
  {
    title: "Support the next stage",
    description:
      "As the work grows, we help refine, expand, or maintain the solution so it continues to create value.",
  },
];

export const reasons = [
  {
    number: "01",
    title: "Business-first thinking",
    description:
      "We start with how your team works, what slows it down, and what kind of software will create measurable value.",
  },
  {
    number: "02",
    title: "Strong product ownership",
    description:
      "From discovery to deployment, we stay close to the work and help shape decisions instead of only shipping tasks.",
  },
  {
    number: "03",
    title: "Practical execution",
    description:
      "We focus on clear architecture, strong delivery habits, and solutions that are realistic for teams to adopt and maintain.",
  },
  {
    number: "04",
    title: "Small team, direct communication",
    description:
      "You work with the people building the product, which keeps feedback fast and reduces handoff friction.",
  },
];

export const teamMembers = [
  {
    name: "Peter Osodo Wanga",
    role: "Founder / Senior Software Engineer",
    bio: "Senior Software Engineer and founder with expertise in designing scalable enterprise systems, cloud-native applications, and fintech solutions. Leads end-to-end product development, software architecture, and engineering delivery, transforming complex business requirements into secure, high-performance digital platforms.",
    image: "assets/img/team/osodo.jpg",
    links: [
      { url: "https://x.com/Ptahosodo", icon: "bi-twitter-x", label: "X" },
      {
        url: "https://www.linkedin.com/in/peter-osodo-4a47631a7/",
        icon: "bi-linkedin",
        label: "LinkedIn",
      },
    ],
  },
  {
    name: "Samantha Wanjiku",
    role: "Digital Marketing Specialist / Business Analyst",
    bio: "Bridges business objectives and customer needs through market research, product analysis, and strategic marketing. Translates insights into clear messaging, actionable requirements, and effective go-to-market strategies that drive growth and customer engagement.",
    image: "assets/img/team/Sam.jpg",
    links: [
      {
        url: "https://www.linkedin.com/company/106085131/",
        icon: "bi-linkedin",
        label: "LinkedIn",
      },
    ],
  },
  {
    name: "Codex",
    role: "AI Software Engineering Assistant",
    bio: "Supports the engineering team with software design, code generation, architecture reviews, debugging, technical documentation, and best-practice recommendations. Accelerates development workflows while helping maintain code quality, scalability, and reliability across projects.",
    image: "assets/img/team/Codex.jpg",
    links: [
      {
        url: "https://openai.com",
        icon: "bi-globe",
        label: "Website",
      },
    ],
  },
];

export const faqs = [
  {
    question: "What does Operating Software build?",
    answer:
      "We build client software, internal business tools, and tailored digital systems for businesses that need practical solutions around real operations.",
  },
  {
    question: "Do you work on client projects?",
    answer:
      "Yes. We support client projects directly and shape software around each business context, workflow, and growth need.",
  },
  {
    question: "Can you help improve an existing system?",
    answer:
      "Yes. We can refine an existing product, modernize old workflows, or help stabilize a codebase that has outgrown its original setup.",
  },
  {
    question: "What is your typical working style?",
    answer:
      "We prefer direct collaboration, short feedback loops, and clear milestones. That keeps momentum high and makes it easier to adapt as the business learns.",
  },
  {
    question: "How do we start a project with you?",
    answer:
      "Reach out through the contact section with your business context, current pain points, and the kind of outcome you want. We can then map the next practical step together.",
  },
];

export const updates = [
  {
    title: "Client delivery with real operational context",
    date: "For active partners",
    author: "Operating Software",
    category: "Client Work",
    image: "assets/img/blog/blog-post-1.webp",
    summary:
      "We focus on software that supports the actual day-to-day flow of a business, not just a polished demo.",
    link: "#contact",
    linkLabel: "Start a conversation",
    external: false,
  },
  {
    title: "Custom software shaped around operations",
    date: "Current focus",
    author: "Operating Software",
    category: "Delivery",
    image: "assets/img/blog/blog-post-2.webp",
    summary:
      "We build systems around the realities of how teams work so the software stays useful long after launch.",
    link: "#contact",
    linkLabel: "Discuss your needs",
    external: false,
  },
  {
    title: "Small team, direct execution",
    date: "How we work",
    author: "Operating Software",
    category: "Approach",
    image: "assets/img/blog/blog-post-3.webp",
    summary:
      "Working closely with decision-makers helps us move faster, reduce waste, and ship software that actually gets used.",
    link: "https://www.linkedin.com/company/106085131/",
    linkLabel: "Follow updates",
    external: true,
  },
];

export const contactDetails = {
  address: "Thika - Mang'u Road, Thika West Center",
  phone: "+254 791 335 490",
  email: "info.operatingsoftware@gmail.com",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.1567909361083!2d37.05602411122215!3d-1.0433779354058959!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f4fe4adf293d9%3A0xeecc2cb049f83e22!2sThika%20West%20Centre!5e0!3m2!1sen!2ske!4v1726122942834!5m2!1sen!2ske",
};

export const footerLinks = [
  { text: "Home", href: "#hero" },
  { text: "About", href: "#about" },
  { text: "Work", href: "#services" },
  { text: "Services", href: "/services" },
  { text: "Contact", href: "#contact" },
];

export const productLinks = [
  { text: "Julian Interiors", href: "/projects/julian-interiors" },
  { text: "Keja Zone", href: "/projects/keja-zone" },
  { text: "Lease Matrix", href: "/projects/lease-matrix" },
];

export const socialLinks = [
  { href: "https://x.com/OSLtdOfficial", icon: "bi-twitter-x", label: "X" },
  {
    href: "https://www.instagram.com/osltdofficial/",
    icon: "bi-instagram",
    label: "Instagram",
  },
  {
    href: "https://www.linkedin.com/company/106085131/",
    icon: "bi-linkedin",
    label: "LinkedIn",
  },
];
